<template>
    <a class="inline-flex justify-center rounded-lg border py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-md transition-colors border-gray-300 text-gray-700 hover:border-gray-400 active:bg-gray-100 active:text-gray-700/80"
        variant="outline" color="gray" href="#"><svg viewBox="0 0 24 24"
            fill="none" aria-hidden="true" class="h-6 w-6 flex-none">
            <circle cx="12" cy="12" r="11.5" stroke="#D4D4D4"></circle>
            <path
                d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
                fill="#A3A3A3" stroke="#A3A3A3"></path>
        </svg><span class="ml-2.5">Watch the video</span></a>
</template>